document.addEventListener('DOMContentLoaded', function() {
  const gridContainer = document.getElementById('ProductGridContainer');
  const listBtn = document.getElementById('listViewBtn');
  const gridBtn = document.getElementById('gridViewBtn');

  // Retrieve saved view (default to grid)
  const savedView = localStorage.getItem('collectionView') || 'view__list-view';
  gridContainer.classList.add(savedView);

  // Function to apply correct button styles
  function updateButtonStyles(view) {
    if (view === 'view__list-view') {
      listBtn.classList.add('button__primary');
      listBtn.classList.remove('button__alternative');
      gridBtn.classList.add('button__alternative');
      gridBtn.classList.remove('button__primary');
    } else {
      gridBtn.classList.add('button__primary');
      gridBtn.classList.remove('button__alternative');
      listBtn.classList.add('button__alternative');
      listBtn.classList.remove('button__primary');
    }
  }

  // Initialize button styles on page load
  updateButtonStyles(savedView);

  // Function to switch view
  function setView(viewClass) {
    gridContainer.classList.remove('view__list-view', 'view__grid-view');
    gridContainer.classList.add(viewClass);
    localStorage.setItem('collectionView', viewClass);
    updateButtonStyles(viewClass);
  }

  // Event listeners
  listBtn.addEventListener('click', () => setView('view__list-view'));
  gridBtn.addEventListener('click', () => setView('view__grid-view'));
});